const ArchiveMusicVideos2025Static = () => {
    return (
      <>
        <div class="music-video">

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/fFDR1wDZPXI" title="6FEET" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lugosi</strong><br/>
            6FEET
          </p>

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/_K4EdPrYcGE" title="6FEET" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Kawaii Ry & Meauxminy</strong><br/>
            Sometimes (I Know)
          </p>
            
        </div>
      </>
    );
  };
  export default ArchiveMusicVideos2025Static;